(ns manatee.admin.components
  "General-purpose admin. components."
  (:require
   [manatee.admin.handlers :as handlers]
   [manatee.admin.subs :as admin-subs]
   [manatee.components.modal.view :as modal-view]
   [re-frame.core :as rf]
   [rothko.button.component :as button-component]
   [rothko.form2.component :as form]))

(defn form-field-props
  [value on-change]
  {::form/set-value-cleanly! on-change
   ::form/set-value! on-change
   ::form/set-clean! identity
   ::form/set-dirty! identity
   ::form/value value
   :appearance #{:primary}})

(defn confirmation-dialog
  "An Ok/Cancel confirmation dialog"
  [{:keys [id ok-fn cancel-fn]
    :as   _props} & children]
  [modal-view/modal-container {:id           id
                               :dismissable? false}
   (-> [:div.admin-page__confirmation-dialog-content]
       (into (vec children))
       (conj [:div.form-row
              [button-component/button {:appearance #{:primary}
                                        :on-click   ok-fn}
               "Ok"]
              [button-component/button {:appearance #{:secondary}
                                        :on-click   cancel-fn}
               "Cancel"]]))])

(defn- user-guide-upload-file-input-component
  []
  [:div.form__input
   [:label.form__label.primary {:for :user-guide-document :style {:display :block}}
    "Select a PDF document: "]
   [:input {:type :file
            :id :user-guide-file-select
            :name :user-guide-file-select
            :accept ".pdf"
            :on-change #(rf/dispatch [::handlers/set-user-guide-payload (some-> %
                                                                                .-target
                                                                                .-files
                                                                                (aget 0))])}]])

(defn- user-guide-upload-submit-button-component
  []
  (let [payload-valid? @(rf/subscribe [::admin-subs/user-guide-payload])]
    [:button.rothko-btn.secondary {:type :button
                                   :disabled (not payload-valid?)
                                   :on-click #(rf/dispatch [::handlers/upload-user-guide])}
     "Update User Guide"]))

(defn user-guide-upload-form-component
  []
  [:div
   [:form {:class [:admin-page__user-guide-form]}
    [:div.form__input
     [:fieldset
      [user-guide-upload-file-input-component]
      [:br]
      [user-guide-upload-submit-button-component]]]]])
